var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.TripRespond = YouLi.Trip.TripRespond ? YouLi.Trip.TripRespond : {};

(function (YouLi) {
    (function (Trip) {
        (function (TripRespond) {

            var currentTripRespondForm = "";

            // need to be a global action as recaptcha call back
            window.TripResponseSubmit = function (token) {

                $("#RecaptchaToken").val(token);

                var form = $("#AddEditTripUser");
                var formData = new FormData(form[0]);

                YouLi.Common.Post({
                    url: '/Trip/InviteeRespond',
                    params: formData,
                    contentType: false,
                    errorCallback: YouLi.Trip.ExpressInterestFormFailure
                }).then(YouLi.Trip.ExpressInterestFormSuccess);
            };

            TripRespond.initFormSubmission = function () {
                $("#AddEditTripUser").on("submit", function (e) {
                    e.preventDefault();
                    var form = $(this);
                    currentTripRespondForm = form;

                    if (form.valid()) {
                        var formSubmitBtn = form.find("input[type='submit']");
                        YouLi.Common.UI.ShowInputLoading(formSubmitBtn);
                        YouLi.Common.UI.ShowLoading();

                        var includeRecaptcha = $("#IncludeGoogleRecaptcha").val();

                        if (includeRecaptcha && includeRecaptcha.toLowerCase() === "true") {
                            // despite reCaptcha script was loaded with render parameter, still a good practice to include Site Key when calling .execute
                            grecaptcha.ready(function () {
                                //The "action"" string  is simply an arbitrary label describing the user interaction.It does not tie directly to a specific controller action or route.
                                grecaptcha.execute("6LelFRkrAAAAACIfEO5pWIRIltUbxfbnBo9LtGQ1", { action: "TripPageRegistration" })
                                    .then(function (token) {
                                        window.TripResponseSubmit(token);
                                    });
                            });
                        }
                        else
                        {
                            window.TripResponseSubmit("");
                        }
                    }
                    return false;
                })
            }

            $(document).ready(function () {
                TripRespond.initFormSubmission();
                YouLi.Trip.FlightTracking.InitFlightCheckButtons();
            });

        }(YouLi.Trip.TripRespond ? YouLi.Trip.TripRespond : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));